import '../shell.css';
import { deckle } from '../../core/deckle';
import { injectFonts } from '../fonts';

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, cls?: string, text?: string): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text !== undefined) e.textContent = text;
  return e;
}

/** 机の全面（ログイン・規約・位置情報の画面の土台）。root の中に置く */
export function createScreen(root: HTMLElement): HTMLElement {
  injectFonts();
  const s = h('div', 'sh-screen');
  s.setAttribute('role', 'dialog');
  s.setAttribute('aria-modal', 'true');
  root.appendChild(s);
  return s;
}

/** 耳付きの紙。大きさが変わったら切り直す。返り値の sheet に中身を入れる */
export function createSheet(seed: number): { wrap: HTMLElement; sheet: HTMLElement } {
  const wrap = h('div', 'sh-sheet-wrap');
  const sheet = h('div', 'sh-sheet');
  wrap.appendChild(sheet);
  const cut = (): void => {
    if (sheet.offsetWidth > 0) sheet.style.clipPath = deckle(sheet.offsetWidth, sheet.offsetHeight, seed);
  };
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(cut).observe(sheet);
  return { wrap, sheet };
}

export function button(label: string, kind: 'ink' | 'paper', onClick: () => void): HTMLButtonElement {
  const b = h('button', `sh-btn sh-btn-${kind}`, label);
  b.type = 'button';
  b.addEventListener('click', onClick);
  return b;
}
